import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateSMSNotificationsModal({
  createSMSNotifications,
  getTransactionList,
  history,
  showTransaction,
  creating,
}) {
  const setModal = useContext(ModalContext);
  const [formMobile, setFormMobile] = useState({});
  const [formData, setFormData] = useState({
    email: '',
    message: '',
  });

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      email: _.get(formData, "email") || "",
      mobile_number: formMobile.mobile_number || "",
      message: _.get(formData, "message") || ""
    }

    createSMSNotifications(args, ({ data }) => {
      setModal({ isOpen: false });
      getTransactionList();
      history.push(`/notifications/transaction/${_.get(data, 'id')}`);
      showTransaction(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Mobile Number:
            </label>
            <FormInputMobile
              disableDropdown={false}
              autoComplete="off"
              autoFocus
              type="tel"
              name="mobile_number"
              onChange={setFormMobile}
              value={formMobile.mobile_number || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Email:
            </label>
            <input
              className="form-control"
              type="email"
              name="email"
              onChange={onChange}
              value={_.get(formData, 'email') || ""}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Message:
            </label>
            <textarea
              className="form-control"
              rows="5"
              type="text"
              name="message"
              onChange={onChange}
              value={_.get(formData, 'message') || ""}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Send`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateSMSNotificationsModal.propTypes = {
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  createSMSNotifications: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_SMS_NOTIFICATIONS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateSMSNotificationsModal);
